import { useMemo } from 'react';
import { JSONContent } from '@tiptap/core';

import { InteractiveText } from '../../shared/interactive-drag-drop/interactive-drag.style';
import { getRichtextValue } from '../../shared/logic/get-richtext-value';
import { INTERACTIVE_RICHTEXT_EXTENSIONS } from '../interactive-response-shared.constants';

type Props = {
  richtext: JSONContent | null;
  baseColour: string | null;
};

const InteractiveResponseRichtextView = ({ richtext, baseColour }: Props) => {
  const text = useMemo(
    () => getRichtextValue(richtext, INTERACTIVE_RICHTEXT_EXTENSIONS),
    [richtext]
  );

  return (
    <InteractiveText
      $baseColour={baseColour}
      dangerouslySetInnerHTML={{
        __html: text,
      }}
    />
  );
};

export default InteractiveResponseRichtextView;
